import axios from 'axios';
import Auth from '../lib/auth';
import utilsLib from './utils.lib';

/*
 * Geography action types
 */

export const GEOGRAPHY_INITIALIZE = 'GEOGRAPHY_INITIALIZE';

export const GEOGRAPHY_COUNTRIES_FETCH_REQUEST = 'GEOGRAPHY_COUNTRIES_FETCH_REQUEST';
export const GEOGRAPHY_COUNTRIES_FETCH_SUCCESS = 'GEOGRAPHY_COUNTRIES_FETCH_SUCCESS';
export const GEOGRAPHY_COUNTRIES_FETCH_ERROR = 'GEOGRAPHY_COUNTRIES_FETCH_ERROR';

export const GEOGRAPHY_PROVINCES_FETCH_REQUEST = 'GEOGRAPHY_PROVINCES_FETCH_REQUEST';
export const GEOGRAPHY_PROVINCES_FETCH_SUCCESS = 'GEOGRAPHY_PROVINCES_FETCH_SUCCESS';
export const GEOGRAPHY_PROVINCES_FETCH_ERROR = 'GEOGRAPHY_PROVINCES_FETCH_ERROR';

export const GEOGRAPHY_TOWNS_FETCH_REQUEST = 'GEOGRAPHY_TOWNS_FETCH_REQUEST';
export const GEOGRAPHY_TOWNS_FETCH_SUCCESS = 'GEOGRAPHY_TOWNS_FETCH_SUCCESS';
export const GEOGRAPHY_TOWNS_FETCH_ERROR = 'GEOGRAPHY_TOWNS_FETCH_ERROR';

/*
 * Geography action creators
 */

/**
 * Initialize Geography
 */
export function initializeGeography() {
    return {
        type: GEOGRAPHY_INITIALIZE
    };
}

/**
 * Get Countries
 */
export function getCountries() {
    return async dispatch => {
        try {
            dispatch(countriesFetchRequest());

            const token = Auth.getLocalJwt();
            const res = await axios.get('/api/geography/countries', { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, countriesFetchSuccess, countriesFetchError));
        } catch (err) {
            dispatch(utilsLib.response(err, countriesFetchError));
        }
    };
}

function countriesFetchRequest() {
    return {
        type: GEOGRAPHY_COUNTRIES_FETCH_REQUEST,
        isFetching: true
    };
}

function countriesFetchSuccess (payload) {
    return {
        type: GEOGRAPHY_COUNTRIES_FETCH_SUCCESS,
        isFetching: false,
        error: false,
        payload
    };
}

function countriesFetchError(errorMessage) {
    return {
        type: GEOGRAPHY_COUNTRIES_FETCH_ERROR,
        isFetching: false,
        error: true,
        errorMessage
    };
}

/**
 * Get Provinces
 * @param countryCode
 */
export function getProvinces(countryCode) {
    return async dispatch => {
        try {
            dispatch(provincesFetchRequest());

            const token = Auth.getLocalJwt();
            const res = await axios.get('/api/geography/countries/' + countryCode + '/provinces', { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, provincesFetchSuccess, provincesFetchError));
        } catch (err) {
            dispatch(utilsLib.response(err, provincesFetchError));
        }
    };
}

function provincesFetchRequest() {
    return {
        type: GEOGRAPHY_PROVINCES_FETCH_REQUEST,
        isFetching: true
    };
}

function provincesFetchSuccess (payload) {
    return {
        type: GEOGRAPHY_PROVINCES_FETCH_SUCCESS,
        isFetching: false,
        error: false,
        payload
    };
}

function provincesFetchError(errorMessage) {
    return {
        type: GEOGRAPHY_PROVINCES_FETCH_ERROR,
        isFetching: false,
        error: true,
        errorMessage
    };
}

/**
 * Get Towns
 * @param countryCode
 * @param provinceCode
 */
export function getTowns(countryCode, provinceCode) {
    return async dispatch => {
        try {
            dispatch(townsFetchRequest());

            const token = Auth.getLocalJwt();
            const res = await axios.get('/api/geography/countries/' + countryCode + '/provinces/' + provinceCode + '/towns', { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, townsFetchSuccess, townsFetchError));
        } catch (err) {
            dispatch(utilsLib.response(err, townsFetchError));
        }
    };
}

function townsFetchRequest() {
    return {
        type: GEOGRAPHY_TOWNS_FETCH_REQUEST,
        isFetching: true
    };
}

function townsFetchSuccess (payload) {
    return {
        type: GEOGRAPHY_TOWNS_FETCH_SUCCESS,
        isFetching: false,
        error: false,
        payload
    };
}

function townsFetchError(errorMessage) {
    return {
        type: GEOGRAPHY_TOWNS_FETCH_ERROR,
        isFetching: false,
        error: true,
        errorMessage
    };
}



// WEBPACK FOOTER //
// ./src/actions/geography.js